module.exports = __webpack_public_path__ + "img/stock0.256cb85e.png";